import { FunctionComponent } from 'react';

import SectionHero from 'components/modules/public/layout/sections/HeroAlt';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageHomeSectionHero: FunctionComponent<Props> = ({
    title,
    subtitle,
    background,
    backgroundAlt,
}) => {
    return (
        <StyledComponent
            className="public-page-employer-articles-section-hero"
        >
            <SectionHero
                title={title}
                subtitle={subtitle}
                background={background}
                backgroundAlt={backgroundAlt}
            />
        </StyledComponent>
    );
};

export default PublicPageHomeSectionHero;